import React, { useEffect, useMemo, useReducer, useState } from "react";
import { useChannel, useClient, useExternalUsers, useTranslation, } from "../../hooks";
import S from "./ChannelMember.styled";
import User from "../User/User";
import SearchIcon from "../../assets/icons/SearchIcon";
import { memberListInitialState, memberListReducer } from "./reducer";
import UserItem from "../UserList/UserItem";
import isSubstring from "../utils";
import useModal from "../../hooks/useModal";
import Modal from "../Ui/Modal/Modal";
const ChannelMember = ({ handleLeaveGroup, handleSendMessage, handleEscapeEvent, }) => {
    const [state, dispatch] = useReducer(memberListReducer, memberListInitialState);
    const channel = useChannel();
    const client = useClient();
    const users = useExternalUsers();
    const strings = useTranslation();
    const { isShown: leaveGroupIsShown, toggle: leaveGroupToggle } = useModal();
    const { isShown: removeMemberIsShown, toggle: removeMemberToggle } = useModal();
    const [queryString, setQueryString] = useState("");
    const [usersIds, setUsersIds] = useState(new Set());
    const [removedMember, setRemovedMember] = useState(null);
    const userNotMembers = useMemo(() => {
        const newMap = new Map(users);
        state.membersIds.forEach((id) => newMap.delete(id));
        return [...newMap.values()];
    }, [users, state.membersIds]);
    const dataMembers = useMemo(() => {
        const members = state.membersIds.map((id) => users.get(id));
        const definedMembers = [];
        members.forEach((m) => {
            if (m !== undefined) {
                definedMembers.push(m);
            }
        });
        return definedMembers;
    }, [state.membersIds, users]);
    const filteredUsers = useMemo(() => {
        return [...userNotMembers.values()].filter((u) => {
            var _a;
            return isSubstring(u.name, queryString) ||
                isSubstring((_a = u.email) !== null && _a !== void 0 ? _a : "", queryString);
        });
    }, [userNotMembers, queryString]);
    const isModerator = channel.moderators.some((m) => m.includes(channel.currentUserId));
    const handleAddUsers = () => {
        channel.addMembers(Array.from(usersIds));
        setUsersIds(new Set());
    };
    useEffect(() => {
        dispatch({
            type: "initialize",
            membersIds: channel.data.members || [],
        });
        const unsubscribeFunctions = [
            channel.on("removeMembers", (event) => {
                const { members } = event;
                dispatch({
                    type: "removeMembers",
                    membersIds: members,
                });
            }),
            channel.on("addMembers", (event) => {
                const { members } = event;
                dispatch({
                    type: "addMembers",
                    membersIds: members,
                });
            }),
        ];
        return () => {
            unsubscribeFunctions.forEach((f) => f.unsubscribe());
        };
    }, [channel, users]);
    return (React.createElement(S.Wrapper, { onKeyDown: (e) => {
            if (e.key === "Escape" && handleEscapeEvent) {
                handleEscapeEvent();
            }
        } },
        React.createElement(S.Header, null,
            "Members of #",
            channel.name),
        React.createElement(S.LeaveButton, { onClick: leaveGroupToggle }, "Leave Group"),
        React.createElement(Modal, { isShown: leaveGroupIsShown, hide: leaveGroupToggle, modalContent: strings.leaveGroupConfirmation, headerText: strings.leaveGroupTitle, handleDelete: () => {
                channel.removeMembers([channel.currentUserId]);
                handleLeaveGroup();
            }, handleCancel: leaveGroupToggle }),
        React.createElement(S.Container, null,
            React.createElement(S.MembersList, null,
                dataMembers.map((m) => (React.createElement(S.ListItem, { key: m.id },
                    React.createElement(User, { user: m, isChannelMemberListOpen: true, isModerator: channel.moderators.some((c) => c === m.id) }),
                    React.createElement(S.ButtonWrapperMembers, { "data-testid": "ButtonWrapperMembers" },
                        channel.currentUserId !== m.id && (React.createElement(S.Button, { onClick: () => {
                                const newChannel = client.channel("private", "", {
                                    name: "Private Channel",
                                    members: [client.user.id, m.id],
                                });
                                newChannel.watch().then(() => {
                                    handleSendMessage(newChannel);
                                });
                            } }, "Send message")),
                        isModerator && (React.createElement(S.RemoveButton, { onClick: () => {
                                setRemovedMember(m);
                                removeMemberToggle();
                            } }, "Remove")))))),
                React.createElement(Modal, { isShown: removeMemberIsShown, hide: removeMemberToggle, modalContent: strings.deleteConfirmationMember, headerText: strings.deleteMemberTitle, handleDelete: () => {
                        if (!removedMember)
                            return;
                        channel.removeMembers([removedMember.id]);
                        removeMemberToggle();
                    }, handleCancel: removeMemberToggle })),
            isModerator && (React.createElement(S.UserContainer, null,
                React.createElement(S.ButtonWrapper, null,
                    React.createElement(S.ChannelSearchContainer, null,
                        React.createElement(S.ChannelSearchInputWrapper, null,
                            React.createElement(S.ChannelSearchInputIcon, null,
                                React.createElement(SearchIcon, { fill: "gray" }),
                                React.createElement(S.ChannelSearchInputText, { type: "search", placeholder: strings.typeUser, onChange: (e) => {
                                        setQueryString(e.target.value);
                                    } })))),
                    React.createElement(S.AddButton, { type: "button", disabled: usersIds.size < 1, onClick: handleAddUsers }, "Add users")),
                React.createElement(S.UserList, null, filteredUsers.map((user) => (React.createElement("li", { key: user.id },
                    React.createElement(UserItem, { user: user, handleToggle: (checked) => {
                            if (checked) {
                                usersIds.add(user.id);
                            }
                            else {
                                usersIds.delete(user.id);
                            }
                            setUsersIds(new Set(usersIds));
                        }, selected: usersIds.has(user.id) }))))))))));
};
export default ChannelMember;
//# sourceMappingURL=ChannelMember.js.map